import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 42, height: 32, viewBox: "0 0 42 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 42, height: 32, rx: 16, fill: "#E6ECF1" }), /* @__PURE__ */ React.createElement("path", { d: "M27.75 22.75H14.25M25.5 15.25L21 19.75M21 19.75L16.5 15.25M21 19.75V9.25", stroke: "#222222", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
